import React, {
    Component
} from 'react';
class Environment extends Component {
    isValidated() {
        // Check if environment is selected (either INTERNAL or BOTH)
        const environment = this.props.getStore().environment;
        return environment === "INTERNAL" || environment === "BOTH";
    }
    //lambda ensures correct 'this' scope
    onChange = (e) => {
        this.props.updateStore({
            environment: e.target.value
        });
    }
    render() {
        return <div>
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <br />
                        <h4>How will your service be consumed?</h4>
                        <br />
                        <div className="hzn-radio-card-wrapper">
                            <div className="radio hzn-radio-card">
                                <input type="radio" name="environment" id="internal" value="INTERNAL" checked={this.props.getStore().environment === "INTERNAL"} onChange={this.onChange} />
                                <label htmlFor="internal">Internal <i>(api.theprincipal.net)</i></label>
                            </div>
                            <div className="radio hzn-radio-card">
                                <input type="radio" name="environment" id="both" value="BOTH" checked={this.props.getStore().environment === "BOTH"} onChange={this.onChange} />
                                <label htmlFor="both">External <i>(api.principal.com)</i> <br />(if your ONLY external call will be through the Ajax proxy, choose Internal)</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default Environment;
